// Copyright (c) Move Closer 2022.

import VueI18n from 'vue-i18n'
import VueRouter from 'vue-router'

import { logger } from '../../../../support'

import { NavItemProps } from '../../../../dsl/molecules/Nav'

import { ProfileTab } from '../../services/profile-tabs'

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export const translateProfileElementToProfileTabsProps = (
  profileTabs: ProfileTab[],
  i18n: VueI18n,
  router: VueRouter
): NavItemProps[] => {
  return profileTabs.map(profileTab => {
    const target = router.resolve({ name: profileTab.routeName }).resolved.path
    if (!target) {
      logger(`[Target]: Wrong route name for ${profileTab.routeName}`, 'debug')
    }

    return {
      label: i18n.t(`front.profile.views.productWrapper.${profileTab.label}`).toString(),
      target
    }
  })
}
